import React, { Component } from 'react';
import { object, string, bool, array, func } from 'prop-types';
import classnames from 'classnames/bind';

import AutoComplete from 'common/AutoComplete/AutoComplete';
import TextArea from './TextArea';
import { sizeMap, actionIconsMap } from './common';

/*

  Input Layer, fourth and last level of the input tree.
  This component will be responsible for feeding all the props to the input.
  It also decides which type of input to render (autocomplete, textarea, etc).

*/

export default class Input extends Component {
  static propTypes = {
    sharedProps: object,
    type: string,
    value: string,
    multiline: bool,
    readOnly: bool,
    error: object,
    autoComplete: array,
    customClasses: string,
    onBlur: func,
    onFocus: func,
    icon: object,
    actionIcon: object,
    hideActionIcon: bool,
    onIconClick: func,
    onChange: func,
    placeholder: string,
  };

  static defaultProps = {
    error: { error: false }
  };

  handleFocus = e => {
    const { onFocus } = this.props;

    onFocus && onFocus(e);
  }

  handleBlur = e => {
    const { onBlur } = this.props;

    onBlur && onBlur(e);
  }

  handleIconClick = e => {
    const { onIconClick, actionIcon: { icon } } = this.props;

    onIconClick && onIconClick({ event: e, action: actionIconsMap[icon] });
  }

  renderIcon = () => {
    const { hideActionIcon, icon, actionIcon, sharedProps:{styles} } = this.props;
    const cx = classnames.bind(styles);

    let Icon = null;
    let ActionIcon = null;

    if (icon) {
      Icon = require('foundations/Icons/Icon').default;
    } else if (actionIcon) {
      ActionIcon = require('elements/ActionIcons/ActionIcon').default;
    }

    return (
      icon ?
        <Icon
          icon={icon.icon}
          type={icon.type}
          customClasses={styles.iconRight}
          key='one'
        /> :
      actionIcon ?
        <ActionIcon
          icon={actionIcon.icon}
          type={actionIcon.type}
          customClasses={cx('iconRight', 'actionIcon', { hide: hideActionIcon })}
          onClick={this.handleIconClick}
          key='one'
        />
      : null
    );
  }

  render() {
    const {
      sharedProps,
      multiline,
      value,
      customClasses,
      readOnly,
      autoComplete,
      error,
      type,
      placeholder,
      onChange,
    } = this.props;

    const { size, disabled, readonly, styles } = sharedProps;
    const inputClasses = classnames(customClasses, sizeMap[size], {
      [styles.filled]: value.length,
      [styles.hasError]: error.error
    });

    const inputProps = {
      className: `${styles.input} ${inputClasses}`,
      disabled,
      type,
      value,
      size,
      placeholder,
      onChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      readOnly: readOnly || readonly,
    };

    return (
      <div className="relative">
        {
          !multiline
            ? autoComplete
                ? <AutoComplete inputProps={inputProps} items={autoComplete} />
                : <input {...inputProps} />
            : <TextArea {...inputProps} />
        }
        {this.renderIcon()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/Input.js